import type { Role } from '@/types/roles';

const MFA_ELIGIBLE_ROLES: Role[] = ['ADMIN', 'BO', 'BM', 'MANAGER'];

/** MFA enrolment is currently offered to accounts with elevated workspace access. */
export function canConfigureMfa(role: Role | null | undefined) {
  return role ? MFA_ELIGIBLE_ROLES.includes(role) : false;
}
